import { render, staticRenderFns } from "./VivaTooltip.vue?vue&type=template&id=3dc568d1&scoped=true"
import script from "./VivaTooltip.vue?vue&type=script&lang=js"
export * from "./VivaTooltip.vue?vue&type=script&lang=js"
import style0 from "./VivaTooltip.vue?vue&type=style&index=0&id=3dc568d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc568d1",
  null
  
)

export default component.exports